var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIcLink = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "jj05me91wa",
    d: "M3.25 10c0-1.425 1.158-2.583 2.583-2.583h3.334V5.833H5.833c-2.3 0-4.166 1.867-4.166 4.167s1.866 4.167 4.166 4.167h3.334v-1.584H5.833c-1.425 0-2.583-1.158-2.583-2.583zm3.417.833h6.666V9.167H6.667v1.666zm7.5-5h-3.334v1.584h3.334c1.425 0 2.583 1.158 2.583 2.583 0 1.425-1.158 2.583-2.583 2.583h-3.334v1.584h3.334c2.3 0 4.166-1.867 4.166-4.167s-1.866-4.167-4.166-4.167z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "yfv21evu6b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#jj05me91wa"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#4F5964",
    mask: "url(#yfv21evu6b)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "color-fill",
    d: "M0 0H41.667V41.667H0z",
    transform: "translate(-10.833 -10.833)"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcLink, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ic-link.97fd2682.svg";
export { ForwardRef as ReactComponent };